export const LOGIN_BASE_URL = 'https://auth.travel.rakuten.co.jp/fwd/memberDispatcher/login';
export const LOGIN_RETURN_URL = 'cgi-bin/rakuten_id_reference';
export const LOGIN_SERVICE_ID = 'omnit01'